var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

import ContextFactory from "../Context";
var DEFAULT_STATE = {
  history: [],
  historyCursor: -1,
  overlay: null,
  itemTimeSettingsForm: null,
  currentTime: 0,
  onOverlayChange: null
};
var OverlayContext = (_temp = _class = function OverlayContext(propagateMutation) {
  var _this = this;

  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _extends({}, DEFAULT_STATE);

  _classCallCheck(this, OverlayContext);

  _initialiseProps.call(this);

  this.state = state;

  this._propagateMutation = function () {
    propagateMutation(_this);
  };
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setState = function (newState) {
    var oldOverlay = _this2.state.overlay ? _extends({}, _this2.state.overlay) : null;
    Object.keys(newState).map(function (key) {
      return _this2.state[key] = newState[key];
    });

    _this2._propagateMutation();

    if (newState.overlay && _this2.state.onOverlayChange) {
      var hasOverlayChanged = oldOverlay !== null && JSON.stringify(newState.overlay) !== JSON.stringify(oldOverlay);
      hasOverlayChanged && _this2.state.onOverlayChange();
    }
  };

  this.initializeState = function (state, EditorContext) {
    _this2.EditorContext = EditorContext;

    _this2.setState(_extends({}, DEFAULT_STATE, state));
  };

  this.rememberFrame = function (frameSetter) {
    var history = [].concat(_this2.state.history.slice(0, _this2.state.historyCursor + 1), [{
      frameSetter: frameSetter,
      overlay: _this2.state.overlay
    }]);

    _this2.setState({
      history: history,
      historyCursor: _this2.state.historyCursor + 1
    });
  };

  this.rememberOverlay = function (withFrameSetter) {
    setTimeout(function () {
      var overlay = _this2.state.overlay;
      var snapshot = {
        overlay: overlay,
        currentTime: _this2.state.currentTime
      };

      if (!!withFrameSetter) {
        snapshot.frameSetter = withFrameSetter;
      }

      var history = [].concat(_this2.state.history.slice(0, _this2.state.historyCursor + 1), [snapshot]);

      _this2.setState({
        history: history,
        historyCursor: _this2.state.historyCursor + 1
      });
    }, 500);
  };

  this.undo = function () {
    if (_this2.state.historyCursor <= 0) {
      return;
    }

    _this2.setHistoryCursor(_this2.state.historyCursor - 1);
  };

  this.redo = function () {
    if (_this2.state.historyCursor === _this2.state.history.length - 1) {
      return;
    }

    _this2.setHistoryCursor(_this2.state.historyCursor + 1);
  };

  this.setHistoryCursor = function (value) {
    var snapshot = _this2.state.history[value];

    if (!snapshot) {
      return;
    }

    if (snapshot.frameSetter) {
      snapshot.frameSetter();
    }

    var newState = {
      historyCursor: value
    };

    if (snapshot.overlay) {
      // @todo This is totally wrong approach - change private property of the instance from the client code
      _this2.state.canvas.canvasItemsInitialized = false;
      newState.overlay = snapshot.overlay;
    }

    if (snapshot.currentTime !== undefined) {
      newState.currentTime = snapshot.currentTime;

      _this2.EditorContext.video.setCurrentTime(snapshot.currentTime);

      _this2.EditorContext.pauseVideo();
    }

    _this2.setState(newState);
  };

  this.setCanvas = function (canvas) {
    return _this2.setState({
      canvas: canvas
    });
  };

  this.setOverlay = function (overlay) {
    _this2.setState({
      overlay: overlay
    });

    _this2.rememberOverlay();
  };

  this.setCurrentTime = function (time) {
    return _this2.setState({
      currentTime: time
    });
  };

  this.editItemTimeSettings = function (id, confirmCallback) {
    if (!id) {
      var start = Math.round(_this2.state.currentTime * 100) / 100;
      var duration = 3;

      _this2.setState({
        itemTimeSettingsForm: {
          id: id,
          start: start,
          duration: duration,
          confirmCallback: confirmCallback
        }
      });

      return;
    }

    var item = _this2.state.overlay.objects.find(function (object) {
      return object.metadata.id === id;
    });

    _this2.setState({
      itemTimeSettingsForm: _extends({}, item.metadata)
    });
  };

  this.changeItemParam = function (param, value) {
    var itemTimeSettingsForm = _this2.state.itemTimeSettingsForm;

    if (itemTimeSettingsForm) {
      var _extends2;

      _this2.setState({
        itemTimeSettingsForm: _extends({}, itemTimeSettingsForm, (_extends2 = {}, _extends2[param] = value, _extends2))
      });
    }
  };

  this.closeItemTimeSettingsEditor = function () {
    return _this2.setState({
      itemTimeSettingsForm: null
    });
  };

  this.confirmOverlaySettings = function () {
    var itemTimeSettingsForm = _this2.state.itemTimeSettingsForm;

    if (!itemTimeSettingsForm) {
      return;
    }

    var id = itemTimeSettingsForm.id,
        start = itemTimeSettingsForm.start,
        duration = itemTimeSettingsForm.duration,
        confirmCallback = itemTimeSettingsForm.confirmCallback;

    _this2.closeItemTimeSettingsEditor();

    if (id) {
      _this2.state.canvas.changeItemMetadata(id, {
        start: start,
        duration: duration
      });

      return;
    }

    if (confirmCallback) {
      confirmCallback(start, duration);
    }
  };

  this.setOverlayStartPosition = function (id, start) {
    var item = _this2.state.overlay.objects.find(function (object) {
      return object.metadata.id === id;
    });

    _this2.state.canvas.changeItemMetadata(id, _extends({}, item.metadata, {
      start: start
    }));
  };

  this.deleteOverlayItem = function (id) {
    _this2.state.canvas.deleteItemById(id);
  };
}, _temp);

var _ContextFactory = ContextFactory(OverlayContext, "OverlayContext"),
    withProvider = _ContextFactory.withProvider,
    consumeContext = _ContextFactory.consumeContext;

export { withProvider, consumeContext };